import _ from 'lodash';
import React from 'react';
import { Tag, Text } from 'src/@vymo/ui/atoms';
import moment from 'moment';
import { ReactComponent as TeamsIcon } from 'src/assets/navigation/teams.svg';
import { Keys, locale } from 'src/i18n';
import { useAppSelector } from 'src/store/hooks';
import { getKeyMetricsDetails } from '../../selector';
import styles from '../index.module.scss';

function KeyMetricsWebTitle() {
  const details = useAppSelector(getKeyMetricsDetails);

  if (_.isEmpty(details)) return null;
  return (
    <div className={styles.details__webTitle}>
      <Text type="h3">
        {details.card.title}{' '}
        {Boolean(details.card.subordinatesCount) && (
          <Tag>
            <TeamsIcon /> {details.card?.subordinatesCount}
          </Tag>
        )}
      </Text>
      <Text classNames={styles.details__webTitle__description}>
        {locale(Keys.LAST_UPDATED_ON, {
          date: moment(details?.result?.metric?.last_updated_date).format(
            'DD MMM YYYY',
          ),
        })}
      </Text>
    </div>
  );
}

export default KeyMetricsWebTitle;
